import React from "react";
import { AuthProvider } from "./AuthContext";
import { ThemeProvider } from "./ThemeContext";
import { UserProvider } from "./UserContext";
import { PermissionProvider } from "./PermissionContext";
import { RoleProvider } from "./RoleContext";
const SuperProvider = (props) => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <PermissionProvider>
          <RoleProvider>
            <UserProvider>{props.children}</UserProvider>
          </RoleProvider>
        </PermissionProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};
export default SuperProvider;
